/* tslint:disable */
/* eslint-disable */
/**
 * K·HERO
 * K·HERO API documentation
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

 /**
 *
 *
 * @export
 * @interface StagedUploadDto
 */
export interface StagedUploadDto {

    /**
     * Opaque id used to claim the staged file
     *
     * @type {string}
     * @memberof StagedUploadDto
     */
    uploadId: string;

    /**
     * @type {string}
     * @memberof StagedUploadDto
     */
    originalName: string | null;

    /**
     * @type {string}
     * @memberof StagedUploadDto
     */
    mime: string | null;

    /**
     * Size in bytes
     *
     * @type {number}
     * @memberof StagedUploadDto
     */
    size: number;

    /**
     * SHA-256 of the staged contents
     *
     * @type {string}
     * @memberof StagedUploadDto
     */
    checksum: string;

    /**
     * When the staged file expires if never claimed (ISO 8601)
     *
     * @type {string}
     * @memberof StagedUploadDto
     */
    expiresAt: string;
}
